import { MechanicActionsComponent } from './mechanic.actions.component';

export function MechanicsCtrl (
  $filter,
  $rootScope,
  $scope,
  $state,
  $translate,
  confirm,
  mechanics,
  messages,
  messengerApi,
  tableApi,
  workshopAPI
) {
  $scope.mechanics     = mechanics;
  $scope.tableCacheKey = 'mechanics';

  $scope.activate = function (row) {
    confirm.generic($translate.instant('COMPANY_SPACE.INTEGRATIONS.ACTIVATE', {
      name: row.display_name
    }))
    .then(() => workshopAPI.get('/mechanic/reactivate_deleted', row.id))
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.EMPLOYEE_REACTIVATED',
      {
        title: $rootScope.Company.labels.employeeTitle
      }), 'success');

      $state.reload();
    })
    .catch(err => {
      messages.error(err);
    });
  };

  $scope.sendSMS = function (row) {
    messengerApi.sms({
      name   : `${ row.first_name } ${ row.last_name }`,
      send_to: row.mobile
    })
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.MESSAGE_SENT'), 'success');
    });
  };

  $scope.filtering = tableApi.setFiltersFromCache($scope.tableCacheKey, {
    archived_only: false,
    value        : ''
  });

  $scope.tableSettings = {
    broadcast: 'filterMechanics',
    cache    : {
      enabled: true,
      key    : $scope.tableCacheKey
    },
    columns: [
      {
        classes: 'text-left',
        field  : 'display_name',
        header : {
          classes: 'text-left',
          text   : $translate.instant('GENERAL_SPACE.FIELD.NAME')
        }
      },
      {
        field : 'mobile',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.MOBILE')
        },
        pipe: 'mobilePhone'
      },
      {
        component: {
          bindings: {
            outputs: {
              onActivateClick  : event => $scope.activate(event),
              onEditClick      : event => $state.go('app.mechanic', { id: event.id }),
              onMobileUserClick: event => $state.go('app.mobile-user', { mechanic_id: event.id }),
              onSMSClick       : event => $scope.sendSMS(event)
            }
          },
          enabled: true,
          factory: MechanicActionsComponent
        },
        sortable: false
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_RECORDS_FOUND', {
        type: $rootScope.Company.labels.employeeTitle
          ? $filter('pluralize')($rootScope.Company.labels.employeeTitle)
          : $translate.instant('EMPLOYEE_SPACE.EMPLOYEES')
      })
    },
    pagination: {
      enabled   : true,
      pageSize  : tableApi.getCachedPaging($scope.tableCacheKey).pageSize || 10,
      pageSizes : [ 10, 25, 50 ],
      queryCount: () => workshopAPI.get('/mechanics/count')
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: tableApi.setSortingFromCache($scope.tableCacheKey, {
      direction: 'asc',
      field    : 'display_name'
    })
  };

  $scope.getMechanics = ( params ) => {
    return workshopAPI.stream('/filters', [
      $scope.filtering.value || '*',
      'mechanics',
      params.offset,
      params.pageSize,
      params.field,
      params.direction,
      $scope.filtering.archived_only
    ]).then(mechanics => {
      $scope.mechanics = mechanics;

      return mechanics;
    });
  };

  $scope.onRowDoubleClick = function (event) {
    $scope.viewMechanic(event.row);
  };

  $scope.viewMechanic = function (mechanic) {
    $state.go('app.mechanic', {
      id: mechanic.id
    });
  };

  $scope.$watch('[ filtering.value, filtering.archived_only ]', ( newVal, oldVal ) => {
    if (newVal !== oldVal) {
      window['filterMechanics']($scope.filtering);
    }
  }, true);
};